<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12" md="6">
                  <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <b-form-input :validate-error="errors[0]" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_type')">
                            <parameter-selectbox v-model="form.type" :multiple="false"
                                                 :validate-error="errors[0]" code="student_club_types"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <status-selectbox v-model="form.status" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="creation_date" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('foundation_at')">
                            <select-date v-model="form.creation_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="president_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('club_president')">
                            <students-auto-complete-by-key
                                :value="selectedPresident"
                                @user-input="handleSelection"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="instructor_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_advisor')">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="dues" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('fee')">
                            <b-form-input step="0.01" v-model="form.dues"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";
    import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete';
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey"

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";

    export default {
        components: {
            StudentsAutoCompleteByKey,
            ValidationProvider,
            ValidationObserver,

            ParameterSelectbox,
            StatusSelectbox,
            StaffAutoComplete
        },
        data() {
            return {
                formLoading: false,
                selectedPresident: '',
                form: {
                  //
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    this.form.dues = parseFloat(this.form.dues).toFixed(2);
                    if (this.form.status === 'p') {
                        this.form.status = 0;
                    } else if (this.form.status === 'a') {
                        this.form.status = 1;
                    }
                    StudentClubService.store(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
            handleSelection(user) {
                this.form.president_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
            }
        }
    }
</script>
